module.exports = __webpack_public_path__ + "static/media/header-wallet-tokenpocket.f12aa929.svg";